import React, { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { faqData } from '../../mocks/faq';
import { useSEO, generateWebPageSchema, generateBreadcrumbSchema } from '../../utils/seo';

const FAQPage: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  // SEO Configuration
  useSEO({
    title: '常見問題 FAQ - 專任委託跟一般委託差在哪？不動產委託銷售契約書說明',
    description: '解答房仲契約書相關常見問題，包含專任委託跟一般委託差在哪、不動產委託銷售契約書使用方式、契約書範本下載流程、付款方式等。提供專業的房仲專用契約書諮詢服務。',
    keywords: '專任委託跟一般委託差在哪,不動產委託銷售契約書,房仲專用契約書,契約書範本,專任委託合約,房仲買賣契約書,常見問題,FAQ',
    canonical: '/faq',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateWebPageSchema(
          '常見問題 FAQ',
          '解答房仲契約書相關常見問題，包含專任委託跟一般委託差在哪、不動產委託銷售契約書使用方式等',
          '/faq'
        ),
        generateBreadcrumbSchema([
          { name: '首頁', url: '/' },
          { name: '常見問題', url: '/faq' }
        ]),
        {
          '@type': 'FAQPage',
          mainEntity: faqData.map(faq => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer
            }
          }))
        }
      ]
    }
  });

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">常見問題</h1>
            <p className="text-lg text-gray-600">
              以下是客戶最常詢問的問題，如有其他疑問歡迎聯絡我們
            </p>
          </div>

          <div className="space-y-4">
            {faqData.map((faq) => (
              <div
                key={faq.id}
                className="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-lg"
              >
                <button
                  onClick={() => setOpenIndex(faq.id)}
                  className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors duration-300"
                >
                  <h3 className="text-lg font-bold text-gray-800 pr-4">
                    {faq.question}
                  </h3>
                  <i
                    className={`text-2xl text-[#d4af37] transition-transform duration-300 flex-shrink-0 ${
                      openIndex === faq.id ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </button>
                
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === faq.id ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <div className="px-8 pb-6 text-gray-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-gradient-to-br from-[#1a2332] to-[#2d3e50] rounded-2xl p-12 text-center text-white">
            <h2 className="text-2xl font-bold mb-4">還有其他問題？</h2>
            <p className="text-white/80 mb-8">
              我們的客服團隊隨時為您服務，歡迎透過以下方式聯絡我們
            </p>
            <button
              onClick={() => window.REACT_APP_NAVIGATE('/contact')}
              className="px-8 py-3 bg-[#d4af37] text-[#1a2332] font-bold rounded-lg hover:bg-[#c49d2e] transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              聯絡我們
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FAQPage;
